import { render, staticRenderFns } from "./KitchenMaterialPicker.vue?vue&type=template&id=3eb3a490&scoped=true&"
import script from "./KitchenMaterialPicker.vue?vue&type=script&lang=js&"
export * from "./KitchenMaterialPicker.vue?vue&type=script&lang=js&"
import style0 from "./KitchenMaterialPicker.vue?vue&type=style&index=0&id=3eb3a490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb3a490",
  null
  
)

export default component.exports